// src/utils/modules.js
// P4-7 (D-319, MED-36) — the ONE check "is this module on for this company?".
//
// WHY THIS EXISTS: companies/{id}.modules holds the switches, and most
// companies have no entry for most modules. Normal modules are ON unless the
// SuperAdmin switched them off. Opt-in modules are the other way round: OFF
// unless the SuperAdmin set them to exactly true.
//   reports       — the four report pages compute their own money totals, so
//                   they stay hidden until rebuilt from the governed helpers.
//   ai_boq_import — premium add-on; parseBoqWithAI refuses unless === true.
// The sidebar, the routes, Home and the SuperAdmin toggle all read this
// function, so they cannot disagree. Pure, no imports.

export const OPT_IN_MODULES = ["reports", "ai_boq_import"];

export const isModuleOn = (modules, name) => {
  const value = (modules || {})[name];
  return OPT_IN_MODULES.includes(name) ? value === true : value !== false;
};
